export default __webpack_public_path__ + "static/media/45.55646a74.png";